module.exports = __webpack_public_path__ + "static/media/footerSlika.822419f7.png";